import { Col, Flex, Row, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { JPYs, secondaryWorkTypeGroupLengthCount, secondsToHms } from '../common/Common';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { ServiceClass, WorkType } from '../common/enums';

const IQ3KouteiBetsuKesanshiki_BlankLaser = (props) => {
  const [laserProcessInput, setLaserProcessInput] = useState([]);
  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const [isTwoStepHoleOpen, setIsTwoStepHoleOpen] = useState(true);
  const [isJointOpen, setIsJointOpen] = useState(true);

  // out-cut-process
  const [outCutProcessTime, setOutCutProcessTime] = useState(0);
  const [outCutProcessAmt, setOutCutProcessAmt] = useState(0);
  const [outCutLength, setOutCutLength] = useState(0);
  const [outCutSpeed, setOutCutSpeed] = useState(0);
  const [outCutSpeedCoeff, setOutCutSpeedCoeff] = useState(0);
  const [gasCoeff, setGasCoeff] = useState(0);
  const [sizeCoeff, setSizeCoeff] = useState(0);

  // in-cut-process
  const [inCutProcessTime, setInCutProcessTime] = useState(0);
  const [inCutProcessAmt, setInCutProcessAmt] = useState(0);
  const [inCutLength, setInCutLenght] = useState(0);
  const [inCutSpeedCoeff, setInCutSpeedCoeff] = useState(0);
  const [inCutSpeed, setInCutSpeed] = useState(0);

  // double-cut
  const [twiceCutWorkSpeed, setTwiceCutWorkSpeed] = useState(0);
  const [outTwiceCutProcessTime, setOutTwiceCutProcessTime] = useState(0);
  const [outTwiceCutProcessAmt, setOutTwiceCutProcessAmt] = useState(0);
  const [inTwiceCutProcessTime, setInTwiceCutProcessTime] = useState(0);
  const [inTwiceCutProcessAmt, setInTwiceCutProcessAmt] = useState(0);

  // 空送金額/時間
  const [feedRate, setFeedRate] = useState(0);
  const [airDeliLength, setAirDeliLength] = useState(0);
  const [airTransportTime, setAirTransportTime] = useState(0);
  const [airTransportAmount, setAirTransportAmount] = useState(0);

  // ピアス
  const [piercingTime, setPiercingTime] = useState(0);
  const [piercingAmt, setPiercingAmt] = useState(0);
  const [speedPiercingLen, setSpeedPiercingLen] = useState(0);
  const [piercingTimePerSec, setPiercingTimePerSec] = useState(0);

  // ケガキ
  const [speedScribing, setSpeedScribing] = useState(0);
  const [speedScribingLen, setSpeedScribingLan] = useState(0);
  const [speedScribingTime, setSpeedScribingTime] = useState(0);
  const [speedScribingAmt, setSpeedScribingAmt] = useState(0);

  // 2工程穴加工金額/時間
  const [twoStepHoleCnt, setTwoStepHoleCnt] = useState(0);
  const [twoStepHoleTm, setTwoStepHoleTm] = useState(0);
  const [twoStepHoleTime, setTwoStepHoleTime] = useState(0);
  const [twoStepHoleAmt, setTwoStepHoleAmt] = useState(0);

  // ジョイントバラシ加工金額/時間
  const [jointCnt, setJointCnt] = useState(0);
  const [jointTimePerSec, setJointTimePerSec] = useState(0);
  const [jointTime, setJointTime] = useState(0);
  const [jointAmt, setJointAmt] = useState(0);

  const isOutDetailOpen = openInputSubDetailKeys.has('kakou-detail-out');

  const isInDetailOpen = openInputSubDetailKeys.has('kakou-detail-in');

  const isDoubleCutDetailOpen = openInputSubDetailKeys.has('kakou-detail-double-cut');

  const isDoubleCutOutDetailOpen = openInputSubDetailKeys.has('kakou-detail-double-cut-out');

  const isDoubleCutInDetailOpen = openInputSubDetailKeys.has('kakou-detail-double-cut-in');

  const isAirDeliDetailOpen = openInputSubDetailKeys.has('kakou-detail-air-deli');

  const isPierDetailOpen = openInputSubDetailKeys.has('kakou-detail-pier');

  const isScribDetailOpen = openInputSubDetailKeys.has('kakou-detail-scrib');

  const basicSetupTimeSec = props?.deviceMst?.details?.prepBasicTime;

  //装置の作業時間チャージ
  const mWorkHRate = props?.deviceMst.details?.charges.work;

  //装置の段階時間チャージ
  const mSetHRate = props?.deviceMst.details?.charges.prep;

  const dandoriAmt = (basicSetupTimeSec * mSetHRate) / 3600;

  const twoStepHolework = props?.deviceMst.details?.charges.twoStepHolework;

  //装置の段階時間チャージ
  const jointSeparate = props?.deviceMst.details?.charges.jointSeparate;

  useEffect(() => {
    // レーザー工程入力情報取得
    let processInput = props?.laserData?.processInput?.filter((item) => item.processId == props?.processMst?.id)[0];
    if (processInput) {
      setLaserProcessInput(processInput);
    }

    calculateOutCutProcessing();
  }, [props?.laserData]);

  const calculateOutCutProcessing = () => {
    let productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);
    setSizeCoeff(productionQuantityCoeff);

    // 板厚
    let thickness = props?.parameters?.materialIq3?.filter((item) => item.id == props?.laserData?.thickness)?.[0]?.info
      ?.thick;

    //材質
    let materialTypeIq3Id = props?.laserData?.materialTypeIq3Id;
    //材質区分
    let materialTypeId = props?.parameters?.materialTypeIq3?.filter((item) => item.id == materialTypeIq3Id)?.[0]
      ?.materialTypeId;

    let laserProcessInput = props?.laserData?.processInput?.filter((item) => item.processId == props?.processMst?.id);

    let speedOutLen = Number(laserProcessInput?.[0]?.details?.[0]?.dimensionData?.outerDia);
    setOutCutLength(speedOutLen);

    let speedOut = 0;
    // IQX_WEBEST-295 詳細入力の値を見積計算で使用してほしい
    if (
      props?.deviceMst?.details?.isUsedEasyWorkSpeed === undefined ||
      props?.deviceMst?.details?.isUsedEasyWorkSpeed
    ) {
      speedOut = getSagyoSpeed(props?.deviceMst, thickness, materialTypeId);
    } else {
      speedOut = getSagyoOut(props?.deviceMst, thickness, materialTypeId);
    }

    setOutCutSpeed(speedOut);
    let speedOutCoef = getSpeedCoef(props?.deviceMst, speedOutLen, 0);
    setOutCutSpeedCoeff(speedOutCoef);

    //ガス係数
    let gasCoef = getGasCoef(props?.deviceMst, thickness, materialTypeId);
    setGasCoeff(gasCoef);
    speedOut = speedOut * speedOutCoef * gasCoef;

    let sagyoTmOutPerMin = Number.isFinite(speedOutLen / speedOut) ? (speedOutLen / speedOut) * 60 : 0;
    sagyoTmOutPerMin = sagyoTmOutPerMin * productionQuantityCoeff;
    setOutCutProcessTime(sagyoTmOutPerMin);

    let sAmtOut = calSagyoAmt(sagyoTmOutPerMin);
    setOutCutProcessAmt(sAmtOut);

    //
    // 内周切断時間（内周切断長	*	サイズ係数 /	加工速度	＊	加工速度係数	*	ガス係数）

    let speedInLen = Number(laserProcessInput?.[0]?.details?.[0]?.dimensionData?.innerDia);
    let isBlankDrillingCalculationFlg = props?.settingInfo?.[0]?.environments?.isBlankDrillingCalculation;
    if (isBlankDrillingCalculationFlg) {
      // 2次加工の周長をカウントする
      speedInLen = speedInLen + nijiPerimeter;
    }
    setInCutLenght(speedInLen);

    let speedInCoef = getSpeedCoef(props?.deviceMst, speedInLen, 1);
    setInCutSpeedCoeff(speedInCoef);

    if (
      props?.deviceMst?.details?.isUsedEasyWorkSpeed === undefined ||
      props?.deviceMst?.details?.isUsedEasyWorkSpeed
    ) {
      let speedIn = getSagyoSpeed(props?.deviceMst, thickness, materialTypeId);
      setInCutSpeed(speedIn);
      speedIn = speedIn * speedInCoef * gasCoef;
      let sagyoTmInPerMin = Number.isFinite(speedInLen / speedIn) ? (speedInLen / speedIn) * 60 : 0;
      setInCutProcessTime(sagyoTmInPerMin);
      let sAmtIn = calSagyoAmt(sagyoTmInPerMin);
      setInCutProcessAmt(sAmtIn);
    } else {
      let laserAdditions = props?.laserData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0];
      let orgData = JSON.parse(JSON.stringify(laserAdditions?.dataItems));

      let sagyoInDetails = getSagyoIn(
        props?.deviceMst,
        thickness,
        materialTypeId,
        orgData[0].sagyoDetails,
        laserProcessInput?.[0]?.details?.[0]?.quantityList,
        gasCoef
      );

      setInCutProcessTime(sagyoInDetails?.sagyoTmIn);
      setInCutProcessAmt(sagyoInDetails?.sagyoAmtIn);
    }

    // レーザー2度切りの対応
    let materialSurfaceIq3Id = props?.laserData?.materialSurfaceIq3Id;
    let materialSurface = props?.parameters?.materialSurfaceIq3?.filter(
      (item) => item.id === materialSurfaceIq3Id && item.materialTypeIq3Id === materialTypeIq3Id
    );
    let isTwiceCut = materialSurface?.length > 0 ? materialSurface?.[0]?.info?.isTwiceCut : false;
    let twiceCutWorkSpeed = materialSurface?.length > 0 ? materialSurface?.[0]?.info?.workSpeed : 0;
    setTwiceCutWorkSpeed(twiceCutWorkSpeed);

    // 外周の２度切り切断時間（外周切断長＊サイズ係数 /	2度切り加工速度	＊	加工速度係数	*	ガス係数）
    if (isTwiceCut) {
      let twiceCutSpeedOut = twiceCutWorkSpeed * speedOutCoef * gasCoef;
      let sagyoTmOutTwiceCutPerMin = Number.isFinite(speedOutLen / twiceCutSpeedOut)
        ? (speedOutLen / twiceCutSpeedOut) * 60
        : 0;
      sagyoTmOutTwiceCutPerMin = sagyoTmOutTwiceCutPerMin * productionQuantityCoeff;
      setOutTwiceCutProcessTime(sagyoTmOutTwiceCutPerMin);

      let sAmtOutTwiceCut = calSagyoAmt(sagyoTmOutTwiceCutPerMin);
      setOutTwiceCutProcessAmt(sAmtOutTwiceCut);
    }

    // 内周の２度切り切断時間（内周切断長＊サイズ係数 /	2度切り加工速度	＊	加工速度係数	*	ガス係数）
    if (isTwiceCut) {
      let twiceCutSpeedIn = twiceCutWorkSpeed * speedInCoef * gasCoef;
      let sagyoTmInTwiceCutPerMin = Number.isFinite(speedInLen / twiceCutSpeedIn)
        ? (speedInLen / twiceCutSpeedIn) * 60
        : 0;
      sagyoTmInTwiceCutPerMin = sagyoTmInTwiceCutPerMin * productionQuantityCoeff;
      setInTwiceCutProcessTime(sagyoTmInTwiceCutPerMin);
      let sAmtInTwiceCut = calSagyoAmt(sagyoTmInTwiceCutPerMin);
      setInTwiceCutProcessAmt(sAmtInTwiceCut);
    }

    // 空送時間（空送距離	/	送り速度）
    let speedAirDeli = props?.deviceMst?.details?.feedSpeed;
    setFeedRate(speedAirDeli);
    let speedAirDeliLen = Number(laserProcessInput?.[0]?.details?.[0]?.dimensionData?.airFeedDistance);
    setAirDeliLength(speedAirDeliLen);

    let sagyoTmAirDeli = Number.isFinite(speedAirDeliLen / speedAirDeli) ? (speedAirDeliLen / speedAirDeli) * 60 : 0;

    sagyoTmAirDeli = sagyoTmAirDeli * productionQuantityCoeff;
    setAirTransportTime(sagyoTmAirDeli);
    let sAmtDeli = calSagyoAmt(sagyoTmAirDeli);
    setAirTransportAmount(sAmtDeli);

    //
    let nijiProcessMst;
    let processMst = [];
    let deviceMst = []; //テスト用ID;
    if (props?.parameters?.process?.length > 0) {
      processMst = props?.parameters?.process
        ? props?.parameters?.process?.filter(
            (item) => item?.class === ServiceClass.SheetMetal && item.workType === WorkType.SmBlankLaser
          )[0]
        : [];

      nijiProcessMst = props?.parameters?.process
        ? props?.parameters?.process?.filter(
            (item) => item?.class === ServiceClass.SheetMetal && item.workType === WorkType.SmSecondaryWork
          )[0]
        : [];

      // setProcessMst(processMst ? processMst : []);
      if (props?.parameters?.device?.length > 0) {
        deviceMst = props?.parameters?.device?.filter((item) => processMst?.id == item?.processId);
      }
    }
    let secondaryWorkProcessInput;
    let secondaryUsedForCalc = props?.laserData?.processSelect?.details?.filter(
      (i) => i.processId === nijiProcessMst?.id
    )?.[0]?.isUsedForCalc;
    let nijiCnt = 0;
    let nijiPerimeter = 0;
    let secondaryWorkTypeList = [];
    if (nijiProcessMst !== undefined) {
      secondaryWorkProcessInput = props?.laserData?.processInput?.filter(
        (item) => item.processId == nijiProcessMst?.id
      )[0];
      if (secondaryWorkProcessInput !== undefined && secondaryWorkProcessInput?.details !== undefined) {
        secondaryWorkProcessInput?.details.forEach((e) => {
          if (Number(e.diameter) > 0) {
            nijiCnt += Number(e.count);
          }
        });
        secondaryWorkTypeList = secondaryWorkTypeGroupLengthCount(secondaryWorkProcessInput?.details, 1);
        secondaryWorkTypeList.forEach((e) => {
          if (Number(e.length) > 0) {
            let sizePerimeter = Number(e.length) * 3.14;
            sizePerimeter = sizePerimeter * Number(e.count);
            nijiPerimeter += sizePerimeter;
          }
        });
      }
    }

    // ピアス加工時間（1ピアス加工時間	*	箇所数	＊	ガス係数）
    let sagyoTmPiercingPerSec = getSagyoPiercingTm(props?.deviceMst, thickness, materialTypeId);
    setPiercingTimePerSec(sagyoTmPiercingPerSec);
    let piercingcount = 1;
    let diameter = 0;
    let perimeter = 0;
    if (laserProcessInput.length > 0) {
      if (laserProcessInput?.[0]?.details?.[0]?.quantityList) {
        let quantityList = laserProcessInput?.[0]?.details?.[0]?.quantityList;
        quantityList.forEach((e) => {
          if (Number(e.perimeter) !== 0) {
            piercingcount += Number(e.count);
          }
          diameter += Number(e.diameter);
          perimeter += Number(e.perimeter);
        });
      }
    }
    // ブランク加工下穴計算有がONの場合
    if (isBlankDrillingCalculationFlg) {
      // 2次加工）をカウントする
      piercingcount += nijiCnt;
    }
    let speedPiercingLen = piercingcount;
    setSpeedPiercingLen(speedPiercingLen);
    let sagyoTmPiercing = sagyoTmPiercingPerSec * speedPiercingLen * gasCoef;
    sagyoTmPiercing = sagyoTmPiercing * productionQuantityCoeff;
    setPiercingTime(sagyoTmPiercing);
    let sAmtPiercing = calSagyoAmt(sagyoTmPiercing);
    setPiercingAmt(sAmtPiercing);

    // ケガキ加工時間（ケガキ線長	/	加工速度）
    let speedScribing = props?.deviceMst?.details?.scribingSpeed;
    setSpeedScribing(speedScribing);
    let speedScribingLen = Number(laserProcessInput?.[0]?.details?.[0]?.dimensionData?.etchingLength);
    setSpeedScribingLan(speedScribingLen);
    let sagyoTmScribing = Number.isFinite(speedScribingLen / speedScribing)
      ? (speedScribingLen / speedScribing) * 60
      : 0;
    sagyoTmScribing = sagyoTmScribing * productionQuantityCoeff;
    setSpeedScribingTime(sagyoTmScribing);
    let scribingAmt = calSagyoAmt(sagyoTmScribing);
    setSpeedScribingAmt(scribingAmt);

    //
    // 2工程穴加工金額/時間
    let twoStepHoleTm = props?.deviceMst?.details?.twoStepHoleworkTime;
    setTwoStepHoleTm(twoStepHoleTm);
    let twoStepHoleCnt = secondaryUsedForCalc === true ? 0 : nijiCnt;
    setTwoStepHoleCnt(twoStepHoleCnt);
    // 2工程穴加工時間	*	個数
    let twoStepHoleTmsec = twoStepHoleTm * twoStepHoleCnt * productionQuantityCoeff;
    setTwoStepHoleTime(twoStepHoleTmsec);
    let sagyoAmt2Step = calSagyoAmtTwoStepHole(twoStepHoleTmsec);
    setTwoStepHoleAmt(sagyoAmt2Step);

    // ジョイントバラシ加工金額/時間
    let jointTimePerSec = getJointTm(props?.deviceMst, thickness, materialTypeId);
    setJointTimePerSec(jointTimePerSec);
    // 面積
    let area = Number(props?.laserData?.totalSurfaceArea);
    let jointQtySizeThMaster = props?.deviceMst?.details?.jointQtySizeThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item?.isOutOfRange
    )?.[0];
    jointQtySizeThMaster = jointQtySizeThMaster
      ? jointQtySizeThMaster
      : props?.deviceMst?.details?.jointQtySizeThMaster?.[props?.deviceMst?.details?.jointQtySizeThMaster.length - 1];

    let jointCnt = props?.deviceMst?.details?.jointQtyItems?.filter(
      (item) => item.no == jointQtySizeThMaster?.no && !item?.isOutOfRange
    )?.[0]?.value;
    setJointCnt(jointCnt);

    // ジョイントバラシ加工時間	*	個数
    let jointTimeSec = jointTimePerSec * jointCnt * productionQuantityCoeff;
    setJointTime(jointTimeSec);

    let sagyoAmtJt = calSagyoAmtJoint(jointTimeSec, deviceMst);
    setJointAmt(sagyoAmtJt);
  };

  const calSagyoAmtJoint = (dandoriTimeSec) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;
    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * jointSeparate) / 60.0;
    dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const getJointTm = (deviceMst, thickness, materialTypeIq3Id) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    let jointSeparateThickThMaster = deviceMst?.details?.jointSeparateThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
    )?.[0];

    let jointSeparateItems = Object.entries(deviceMst.details?.jointSeparateItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];

    // ジョイント時間
    let childPartsCoeff = 0;
    jointSeparateItems?.map((item, index) => {
      if (index > 0) {
        childPartsCoeff = item?.filter(
          (item) => parseInt(item.no) == jointSeparateThickThMaster?.no && !item?.isOutOfRange
        )?.[0]?.value;
      }
    });
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const calSagyoAmtTwoStepHole = (dandoriTimeSec) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;
    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * twoStepHolework) / 60.0;
    dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const calSagyoAmt = (cSagyoTimeKonpoSec) => {
    // 作業金額
    // 作業時間
    let mWorkHTime = cSagyoTimeKonpoSec;
    let mWorkHTimeMin = mWorkHTime / 60;
    //　加工時間＊時間チャージ
    let cSagyoAmtKonpo = (mWorkHTimeMin * mWorkHRate) / 60.0;
    cSagyoAmtKonpo = Number.isFinite(cSagyoAmtKonpo) ? cSagyoAmtKonpo : 0;
    return cSagyoAmtKonpo;
  };

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.estimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.laserData?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const getSpeedCoef = (deviceMst, len, processType) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    let childPartsCoeff = 0;
    let workSpeedCoeffLengthThMaster = deviceMst?.details?.workSpeedCoeffLengthThMaster?.filter(
      (item) => (item.value == len || item.value > len) && !item?.isOutOfRange
    )?.[0];

    if (processType == 1) {
      // 内周の加工速度係数取得
      childPartsCoeff = deviceMst?.details?.workSpeedCoeffInternalWorkItems?.filter(
        (item) => item.no == workSpeedCoeffLengthThMaster?.no && !item?.isOutOfRange
      )?.[0]?.value;
    } else {
      // 外周の加工速度係数取得
      childPartsCoeff = deviceMst?.details?.workSpeedCoeffExternalWorkItems?.filter(
        (item) => item.no == workSpeedCoeffLengthThMaster?.no && !item?.isOutOfRange
      )?.[0]?.value;
    }
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const getGasCoef = (deviceMst, thickness, materialTypeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;

    let gasCoeffThickThMaster = deviceMst?.details?.gasCoeffThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
    )?.[0];

    let gasCoeffThItems = Object.entries(deviceMst.details?.gasCoeffThItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeId
    )?.[0];

    let gasCoeffThItemsVal = 0;
    gasCoeffThItems?.map((item, index) => {
      if (index > 0) {
        gasCoeffThItemsVal = item?.filter(
          (item1) => parseInt(item1.no) == gasCoeffThickThMaster?.no && !item1?.isOutOfRange
        )?.[0]?.value;
      }
    });

    // IQX_WEBEST-147
    let gasCoeffThMaster = deviceMst?.details?.gasCoeffListItems?.filter(
      (item) => parseInt(item.no) == gasCoeffThItemsVal && !item?.isOutOfRange
    )?.[0];

    let childPartsCoeff = gasCoeffThMaster?.value;
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const getSagyoSpeed = (deviceMst, thickness, materialTypeIq3Id) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 加工速度
    let workSpeedThickThMaster = deviceMst?.details?.workSpeedThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
    )?.[0];

    let workSpeedItems = Object.entries(deviceMst.details?.workSpeedItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];

    // 加工速度
    let childPartsCoeff = 0;
    if (deviceMst.details?.isUsedEasyWorkSpeed) {
      // 簡易値を取得
      workSpeedItems?.map((item, index) => {
        if (index > 0) {
          childPartsCoeff = item?.filter(
            (item) => parseInt(item.no) == workSpeedThickThMaster?.no && !item?.isOutOfRange
          )?.[0]?.value;
        }
      });
    }
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  // IQX_WEBEST-295 詳細入力の値を見積計算で使用してほしい
  const getSagyoOut = (deviceMst, thickness, materialTypeIq3Id) => {
    let speedOut = 0;
    let workSpeedItem = {};
    if (deviceMst == undefined || deviceMst?.length == 0) return speedOut;
    // 加工速度マスタ
    let workSpeedThickThMaster = deviceMst?.details?.workSpeedThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
    )?.[0];
    // 加工速度値
    let workSpeedItems = Object.entries(deviceMst.details?.workSpeedItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];
    // 詳細値を取得
    workSpeedItems?.map((item, index) => {
      if (index > 0) {
        workSpeedItem = item?.filter(
          (item) => parseInt(item.no) == workSpeedThickThMaster?.no && !item?.isOutOfRange
        )?.[0];
      }
    });
    speedOut = workSpeedItem?.speedOutLen;
    speedOut = speedOut === undefined ? 0 : speedOut;
    return speedOut;
  };

  const getSagyoIn = (deviceMst, thickness, materialTypeIq3Id, sagyoDetails, quantityList, gasCoef) => {
    let workSpeedItem = {};
    let sagyoDetailsInfo = sagyoDetails;
    if (deviceMst == undefined || deviceMst?.length == 0) return sagyoDetailsInfo;
    // 加工速度マスタ
    let workSpeedThickThMaster = deviceMst?.details?.workSpeedThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
    )?.[0];
    // 加工速度値
    let workSpeedItems = Object.entries(deviceMst.details?.workSpeedItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];
    // 詳細値を取得
    workSpeedItems?.map((item, index) => {
      if (index > 0) {
        workSpeedItem = item?.filter(
          (item) => parseInt(item.no) == workSpeedThickThMaster?.no && !item?.isOutOfRange
        )?.[0];
      }
    });
    if (workSpeedItem) {
      for (let i = 0; i < quantityList?.length; i++) {
        let holeType = quantityList[i];
        let sizeIndex = 0;
        let holeVal = 0;
        // 丸の場合、丸穴径(Φ) (≦)と条件する
        if (holeType.types === 1) {
          for (let i = 0; i < workSpeedItem.roundHoleDiaThItems?.length; i++) {
            if (Number(holeType.diameter) <= Number(workSpeedItem.roundHoleDiaThItems[i].value)) {
              sizeIndex = i;
              holeVal = Number(holeType.perimeter);
              break;
            }
          }
          // 周長がLサイズより多きの場合、Lサイズを採用
          if (
            sizeIndex === 0 &&
            holeVal > workSpeedItem.roundHoleDiaThItems?.[workSpeedItem.roundHoleDiaThItems?.length - 1]
          ) {
            sizeIndex = 2;
          }
        } else {
          // 丸以外の場合、加工周長(mm)(≦)と条件する
          for (let i = 0; i < workSpeedItem.workLenThItems?.length; i++) {
            if (Number(holeType.perimeter) <= Number(workSpeedItem.workLenThItems[i].value)) {
              sizeIndex = i;
              holeVal = Number(holeType.perimeter);
              break;
            }
          }
          // 周長がLサイズより多きの場合、Lサイズを採用
          if (
            sizeIndex === 0 &&
            Number(holeType.perimeter) > workSpeedItem.workLenThItems?.[workSpeedItem.workLenThItems?.length - 1]?.value
          ) {
            sizeIndex = 2;
            holeVal = Number(holeType.perimeter);
          }
        }

        // 速度取得
        if (sizeIndex === 0) {
          // Sサイズ速度
          let speedInS = workSpeedItem.lenThItems?.[sizeIndex]?.value;
          sagyoDetailsInfo.sagyoInDetails.speedInS = speedInS === undefined ? 0 : speedInS;
          // Sサイズ合計周長
          sagyoDetailsInfo.sagyoInDetails.speedInSLen += holeVal;
          // 加工速度係数
          let speedInCoefS = getSpeedCoef(deviceMst, holeVal, 1);
          // 内周切断時間（内周切断長	*	サイズ係数 /	加工速度	＊	加工速度係数	*	ガス係数）
          let sagyoTmInPerMin = Number.isFinite(holeVal / (speedInS * speedInCoefS * gasCoef))
            ? (holeVal / (speedInS * speedInCoefS * gasCoef)) * 60
            : 0;
          sagyoTmInPerMin = sagyoTmInPerMin * getProductionQuantityCoeff(deviceMst); // IQX_WEBEST-278 加工時間＊生産個数係数
          sagyoDetailsInfo.sagyoInDetails.sagyoTmInS += sagyoTmInPerMin === undefined ? 0 : sagyoTmInPerMin;
          let sAmtIn = calSagyoAmt(sagyoTmInPerMin, deviceMst);
          sagyoDetailsInfo.sagyoInDetails.sagyoAmtInS += sAmtIn === undefined ? 0 : sAmtIn;
        } else if (sizeIndex === 1) {
          // Mサイズ速度
          let speedInM = workSpeedItem.lenThItems?.[sizeIndex]?.value;
          sagyoDetailsInfo.sagyoInDetails.speedInM = speedInM === undefined ? 0 : speedInM;
          // Mサイズ合計周長
          sagyoDetailsInfo.sagyoInDetails.speedInMLen += holeVal;
          // 加工速度係数
          let speedInCoefM = getSpeedCoef(deviceMst, holeVal, 1);
          // 内周切断時間（内周切断長	*	サイズ係数 /	加工速度	＊	加工速度係数	*	ガス係数）
          let sagyoTmInPerMin = Number.isFinite(holeVal / (speedInM * speedInCoefM * gasCoef))
            ? (holeVal / (speedInM * speedInCoefM * gasCoef)) * 60
            : 0;
          sagyoTmInPerMin = sagyoTmInPerMin * getProductionQuantityCoeff(deviceMst); // IQX_WEBEST-278 加工時間＊生産個数係数
          sagyoDetailsInfo.sagyoInDetails.sagyoTmInM += sagyoTmInPerMin === undefined ? 0 : sagyoTmInPerMin;
          let sAmtIn = calSagyoAmt(sagyoTmInPerMin, deviceMst);
          sagyoDetailsInfo.sagyoInDetails.sagyoAmtInM += sAmtIn === undefined ? 0 : sAmtIn;
        } else if (sizeIndex === 2) {
          // Lサイズ速度
          let speedInL = workSpeedItem.lenThItems?.[sizeIndex]?.value;
          sagyoDetailsInfo.sagyoInDetails.speedInL = speedInL === undefined ? 0 : speedInL;
          // Lサイズ合計周長
          sagyoDetailsInfo.sagyoInDetails.speedInLLen += holeVal;
          // 加工速度係数
          let speedInCoefL = getSpeedCoef(deviceMst, holeVal, 1);
          // 内周切断時間（内周切断長	*	サイズ係数 /	加工速度	＊	加工速度係数	*	ガス係数）
          let sagyoTmInPerMin = Number.isFinite(holeVal / (speedInL * speedInCoefL * gasCoef))
            ? (holeVal / (speedInL * speedInCoefL * gasCoef)) * 60
            : 0;
          sagyoTmInPerMin = sagyoTmInPerMin * getProductionQuantityCoeff(deviceMst); // IQX_WEBEST-278 加工時間＊生産個数係数
          sagyoDetailsInfo.sagyoInDetails.sagyoTmInL += sagyoTmInPerMin === undefined ? 0 : sagyoTmInPerMin;
          let sAmtIn = calSagyoAmt(sagyoTmInPerMin, deviceMst);
          sagyoDetailsInfo.sagyoInDetails.sagyoAmtInL += sAmtIn === undefined ? 0 : sAmtIn;
        }
      }
      sagyoDetailsInfo.sagyoInDetails.speedInSLen =
        sagyoDetailsInfo.sagyoInDetails.speedInSLen === undefined
          ? toDecimal(0, 2)
          : toDecimal(sagyoDetailsInfo.sagyoInDetails.speedInSLen, 2);
      sagyoDetailsInfo.sagyoInDetails.speedInMLen =
        sagyoDetailsInfo.sagyoInDetails.speedInMLen === undefined
          ? toDecimal(0, 2)
          : toDecimal(sagyoDetailsInfo.sagyoInDetails.speedInMLen, 2);
      sagyoDetailsInfo.sagyoInDetails.speedInLLen =
        sagyoDetailsInfo.sagyoInDetails.speedInLLen === undefined
          ? toDecimal(0, 2)
          : toDecimal(sagyoDetailsInfo.sagyoInDetails.speedInLLen, 2);
      sagyoDetailsInfo.sagyoTmIn =
        sagyoDetailsInfo.sagyoInDetails.sagyoTmInS +
        sagyoDetailsInfo.sagyoInDetails.sagyoTmInM +
        sagyoDetailsInfo.sagyoInDetails.sagyoTmInL;
      sagyoDetailsInfo.sagyoAmtIn =
        sagyoDetailsInfo.sagyoInDetails.sagyoAmtInS +
        sagyoDetailsInfo.sagyoInDetails.sagyoAmtInM +
        sagyoDetailsInfo.sagyoInDetails.sagyoAmtInL;
    }
    return sagyoDetailsInfo;
  };

  const getSagyoPiercingTm = (deviceMst, thickness, materialTypeIq3Id) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 加工速度
    let piercingTimeThickThMaster = deviceMst?.details?.piercingTimeThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
    )?.[0];

    let piercingTimeThItems = Object.entries(deviceMst.details?.piercingTimeThItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];

    // 加工速度
    let childPartsCoeff = 0;
    piercingTimeThItems?.map((item, index) => {
      if (index > 0) {
        childPartsCoeff = item?.filter(
          (item) => parseInt(item.no) == piercingTimeThickThMaster?.no && !item?.isOutOfRange
        )?.[0]?.value;
      }
    });
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  const twoStepHoleOpen = () => {
    if (isTwoStepHoleOpen) {
      setIsTwoStepHoleOpen(false);
    } else {
      setIsTwoStepHoleOpen(true);
    }
  };

  const jointOpen = () => {
    if (isJointOpen) {
      setIsJointOpen(false);
    } else {
      setIsJointOpen(true);
    }
  };

  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`;
    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
        <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取金額'}</label>
          </div>
        </Col>
        <Col span={12} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'基本段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
          </div>
        </Col>
        <Col span={8} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${basicSetupTimeSec} (${secondsToHms(basicSetupTimeSec)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${basicSetupTimeSec} × ${mSetHRate}) ÷ 3600 = ${JPYs.format(Math.round(dandoriAmt))}`}</label>
          </div>
        </Col>
      </Row>
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>
      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'out')}
        >
          <Col span={24} style={{ paddingLeft: 30 }}>
            {isOutDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'外周切断金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isOutDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingTop: 11, paddingLeft: 50 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <Typography.Text
                    ellipsis={{
                      tooltip: '外周切断長	/	(加工速度 x 加工速度係数 x ガス係数) x サイズ係数',
                    }}
                  >
                    {'外周切断長	/	(加工速度 x 加工速度係数 x ガス係数) x サイズ係数'}
                  </Typography.Text>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outCutLength} / (${outCutSpeed} x ${outCutSpeedCoeff} x ${gasCoeff}) x ${sizeCoeff} = ${outCutProcessTime} (${secondsToHms(
                    outCutProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outCutProcessTime} × ${mWorkHRate} = ${JPYs.format(Math.round(outCutProcessAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outCutSpeed}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outCutLength}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'in')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isInDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'内周切断金額/時間'}</label>
          </Col>
        </Row>
      </div>
      {isInDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingTop: 10, paddingLeft: 50 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断長 / (加工速度 x 加工速度係数 x ガス係数) x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inCutLength} / (${inCutSpeed} x ${inCutSpeedCoeff} x ${gasCoeff}) x ${sizeCoeff} = ${inCutProcessTime} (${secondsToHms(
                    inCutProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inCutProcessTime} × ${mWorkHRate} = ${JPYs.format(Math.round(inCutProcessAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inCutSpeed}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inCutLength}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'double-cut')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isDoubleCutDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'2度切り切断金額/時間'}</label>
          </Col>
        </Row>
      </div>
      {isDoubleCutDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingTop: 10, paddingLeft: 50 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2度切り切断時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2度切り切断金額'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断時間 + 外周切断時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断金額 + 外周切断金額'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outTwiceCutProcessTime} + ${inTwiceCutProcessTime} = ${
                    outTwiceCutProcessTime + inTwiceCutProcessTime
                  } (${secondsToHms(outTwiceCutProcessTime + inTwiceCutProcessTime)})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outTwiceCutProcessAmt} + ${inTwiceCutProcessAmt} = ${JPYs.format(
                    Math.round(outTwiceCutProcessAmt + inTwiceCutProcessAmt)
                  )}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
      <div style={{ display: isDoubleCutDetailOpen && isKakouOpen ? 'block' : 'none', marginLeft: 15 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'double-cut-out')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isDoubleCutOutDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'外周切断金額/時間'}</label>
          </Col>
        </Row>
      </div>
      {isDoubleCutOutDetailOpen && isDoubleCutDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2度切り加工速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断長	/	(2度切り加工速度 x 加工速度係数 x ガス係数) x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'外周切断時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2度切り加工速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outCutLength} / (${twiceCutWorkSpeed} x ${outCutSpeedCoeff} x ${gasCoeff}) x ${sizeCoeff} = ${outTwiceCutProcessTime} (${secondsToHms(
                    outTwiceCutProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outTwiceCutProcessTime} × ${mWorkHRate} = ${JPYs.format(
                    Math.round(outTwiceCutProcessAmt)
                  )}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${twiceCutWorkSpeed}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${outCutLength}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isDoubleCutDetailOpen && isKakouOpen ? 'block' : 'none', marginLeft: 15 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'double-cut-in')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isDoubleCutInDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'内周切断金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isDoubleCutInDetailOpen && isDoubleCutDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2度切り加工速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断長	/	(2度切り加工速度 x 加工速度係数 x ガス係数) x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'内周切断時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2度切り加工速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inCutLength} / (${twiceCutWorkSpeed} x ${inCutSpeedCoeff} x ${gasCoeff}) x ${sizeCoeff} = ${inTwiceCutProcessTime} (${secondsToHms(
                    inTwiceCutProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inTwiceCutProcessTime} × ${mWorkHRate} = ${JPYs.format(
                    Math.round(inTwiceCutProcessAmt)
                  )}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${twiceCutWorkSpeed}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${inCutLength}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'air-deli')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isAirDeliDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'空送金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isAirDeliDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送距離'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'(空送距離	/	送り速度) x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送時間時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送距離'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`(${airDeliLength} / ${feedRate}) x ${sizeCoeff} = ${airTransportTime} (${secondsToHms(
                    outCutProcessTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${airTransportTime} × ${mWorkHRate} = ${JPYs.format(
                    Math.round(airTransportAmount)
                  )}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${feedRate}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${airDeliLength}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'pier')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isPierDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'ピアス加工金額/時間'}</label>
          </Col>
        </Row>
      </div>
      {isPierDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ピアス加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ピアス加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ピアス回数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'1ピアス加工時間 x 箇所数 x ガス係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ピアス加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ピアス回数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${piercingTimePerSec} x ${speedPiercingLen} x ${gasCoeff} = ${piercingTime} (${secondsToHms(
                    piercingTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${piercingTime} × ${mWorkHRate} = ${JPYs.format(Math.round(piercingAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${speedPiercingLen}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${piercingTimePerSec}(${secondsToHms(piercingTimePerSec)})`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'scrib')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isScribDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'ケガキ加工金額/時間'}</label>
          </Col>
        </Row>
      </div>
      {isScribDetailOpen && isKakouOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ線長 / 加工速度 x ガス係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工速度'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${speedScribingLen} / ${speedScribing} x ${gasCoeff} = ${speedScribingTime} (${secondsToHms(
                    speedScribingTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${speedScribingTime} × ${mWorkHRate} = ${JPYs.format(Math.round(speedScribingAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${speedScribing}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${speedPiercingLen}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => twoStepHoleOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isTwoStepHoleOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'2工程穴加工金額/時間'}</label>
        </Col>
      </Row>
      {isTwoStepHoleOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工時間 x 個数 x ガス係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${twoStepHoleTm} x ${twoStepHoleCnt} x ${gasCoeff} = ${twoStepHoleTime} (${secondsToHms(
                    twoStepHoleTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${twoStepHoleTime} × ${twoStepHolework} = ${JPYs.format(
                    Math.round(twoStepHoleAmt)
                  )}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${twoStepHoleCnt}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${twoStepHoleTm}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => jointOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20, display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
          {isJointOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <Typography.Text
            style={{ marginLeft: 5 }}
            ellipsis={{
              tooltip: 'ジョイントバラシ加工金額/時間',
            }}
          >
            {'ジョイントバラシ加工金額/時間'}
          </Typography.Text>
        </Col>
      </Row>

      {isJointOpen && (
        <div style={{ paddingBottom: 8 }}>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工時間 x 個数 x ガス係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${jointTimePerSec} x ${jointCnt} x ${gasCoeff} = ${jointTime} (${secondsToHms(
                    jointTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${jointTime} × ${jointSeparate} = ${JPYs.format(Math.round(jointAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${jointCnt}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${jointTimePerSec}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_BlankLaser;
